export default "__VITE_PUBLIC_ASSET__d56d0d13__"